import "whatwg-fetch"; // Polyfill for Fetch for IE.

import { EnviroConfig } from "../../EnviroConfig";

export class DataService {

  public fetchWithTimeoutRace(url: string, params: string) {

    const timeout = 10000;

    const body = params;

    const headers = new Headers();
    headers.append("Accept", "application/json, text/javascript, */*; q=0.01");
    headers.append("Content-Type", "application/json; charset=UTF-8");

    const config = new EnviroConfig();
    const baseURL = config.unifiedPublishingAlertServiceURL;

    return Promise.race(
      [
        fetch(baseURL + url, { method: "POST", headers, body, credentials: "same-origin" }),

        new Promise((_, reject) =>
          setTimeout(() => reject(new Error("The request to the service for " + url + " timed out.")), timeout),
        ),
      ]);

  }

  public handleResponseErrors(response: any, methodName: string) {
    if (!response.ok) {
      throw Error(methodName + " service: " + response.statusText);
    }
    return response;
  }

}
